import { useContext, useEffect, useState } from "react";
import {
    Bar,
    BarChart,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis, YAxis
} from 'recharts';
import Swal from "sweetalert2";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Footer from "../Footer";
import { useDashboard } from "../Header/DashboardContext";
import Header from "../Header/Header";
import Sidebar1 from "../Sidebar1";

import { FaCalculator, FaListAlt, FaSearch } from "react-icons/fa";
import { HiOutlineDownload } from "react-icons/hi";
import { MdDashboard, MdSupportAgent } from "react-icons/md";
import { TbMapPinCode, TbTruckDelivery } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import { refeshPend } from "../../App";
import { postApi } from "../../components/Admin Master/Area Control/Zonemaster/ServicesApi";
import './dashboard.css';

// Colors for Pie slices






function Dashboard() {
    const [isOpenTrack, setISOpenTrack] = useState(false);
    const [isOpenPin, setISOpenPin] = useState(false);
    const [docketNo, setDocketNo] = useState("");
    const { docket, setDocket,pin,setPin } = useContext(refeshPend);
    const [pincode, setPincode] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const login = JSON.parse(localStorage.getItem("Login"));
    const colors = ["#000", "#000", "#000", "#000", "#000", "#000"];
    const courierData = [
          { name: "Delivery\n8CFT(Dense)", value: 72 },
  { name: "Delivery B2\nC Heavy(5kg)", value: 58 },
  { name: "Bluedart\nSmall", value: 25 },
  { name: "Delivery 6\nCFT", value: 10 },
  { name: "Delivery\nB2C Small", value: 4 },
  { name: "Others", value: 2 }].map(item => ({
  ...item,
  remaining: 100 - item.value
}));
  
    const scanCard = [
        login?.GooglePayScanner1,
        login?.GooglePayScanner2,
        login?.GooglePayScanner2
    ]
    const data1 = [
        {
            name: 'Jan',
            uv: 200,
            pv: 2500,
            amt: 4100,
        },
        {
            name: 'Feb',
            uv: 1000,
            pv: 3398,
            amt: 2210,
        },
        {
            name: 'March',
            uv: 2000,
            pv: 5800,
            amt: 2290,
        },
        {
            name: 'April',
            uv: 780,
            pv: 5908,
            amt: 2000,
        },
        {
            name: 'May',
            uv: 890,
            pv: 3800,
            amt: 2181,
        },
        {
            name: 'June',
            uv: 2390,
            pv: 1800,
            amt: 2500,
        },
        {
            name: 'July',
            uv: 3490,
            pv: 4300,
            amt: 2100,
        },
    ];

    const data2 = [
        { name: "Group A", value: 400 },
        { name: "Group B", value: 300 },
        { name: "Group C", value: 300 },
        { name: "Group D", value: 200 }
    ];

    const cards = [
        {
            name: "Create Shipment",
            color: "green-card",
            logo: <TbTruckDelivery size={35} />,
            action: () => navigate("/dailybooking")
        },
        {
            name: "Track Shipment",
            color: "blue-card",
            logo: <FaSearch size={35} />,
            action: () => setISOpenTrack(true)
        },
        {
            name: "Track PinCode",
            color: "red-card",
            logo: <TbMapPinCode size={35} />,
            action: () => setISOpenPin(true)
        },
        {
            name: "Rate Calculator",
            color: "orange-card",
            logo: <FaCalculator size={35} />,
            action: () => navigate("/dailybooking", { state: { tab: "rate" } })
        },
        {
            name: "All Shipments",
            color: "purple-card",
            logo: <FaListAlt size={35} />,
            action: () => navigate("/statusreport", { state: { tab: "mis" } })
        },
        {
            name: "Bulk Upload",
            color: "sky-card",
            logo: <HiOutlineDownload size={35} />,
            action: () => navigate("/dailybooking", { state: { tab: "excelimport" } })
        },
        {
            name: "Support Ticket",
            color: "pink-card",
            logo: <MdSupportAgent size={35} />,
            action: () => console.log("Support Open")
        }
    ];
    const [walletBalance, setWalletBalance] = useState(0);
    const [walletAmount, setWalletAmount] = useState(0);

    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        setTooltipPosition({ x: e.clientX, y: e.clientY });
    };

    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const { dashboardData } = useDashboard();
    console.log(dashboardData);

    const bk = dashboardData?.booking[0] || {};
    const mf = dashboardData?.manifest || {};
    const ins = dashboardData?.inscon || {};
    const rs = dashboardData?.runsheet || {};
    const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
    const COLORS1 = ["#FFA500", "#000000"];
    const COLORS2 = ["#007BFF", "red"];

    console.log(cards);

    const getWalletLedger = async (CustomerCode) => {
        if (!CustomerCode) return;

        try {
            const response = await postApi(`/Master/getWalletLedgerDocketWise?Customer_Code=${CustomerCode}`);
            if (response.status === 1) {
                setWalletBalance(response.Summary.CurrentBalance);
                setWalletAmount(response.Summary.TotalDebit);
            } else {
                setWalletBalance(0);
                setWalletAmount(0);
            }
        } catch (error) {
            console.error(error);
            setWalletBalance(0);
            setWalletAmount(0);
        }
    };
    useEffect(() => {
        getWalletLedger(JSON.parse(localStorage.getItem('Login'))?.Customer_Code);
    }, []);

    const handleTrack = () => {
        if (!docketNo.trim()) {
            Swal.fire({
                icon: "warning",
                title: "Empty",
                text: "Enter Docket Number!",
                customClass: {
                    popup: "swal-above-modal"
                }
            });
            return;
        }

        setDocket(docketNo)

        setISOpenTrack(false);
        setDocketNo("");
    };

    const handleTrackPin = () => {
        if (!pincode) {
            Swal.fire({
                icon: "warning",
                title: "Empty",
                text: "Enter Pincode!",
                customClass: {
                    popup: "swal-above-modal"
                }
            });
            return;
        }

        // Add pincode logic here
        setPin(pincode)
        setISOpenPin(false);
        setPincode("");
    };

    return (
        <>
            <Header />
            <Sidebar1 />

            <div id="main-body">
                <div className="dashboard-container">
                    <div className="top-div">
                        <div className="top-right">
                            <span className="top-icon">
                                <MdDashboard />
                            </span>

                            <span className="top-text">
                                Booking Analytics Dashboard
                            </span>
                        </div>
                        {JSON.parse(localStorage.getItem("Login"))?.Customer_Code && <div className="top-left">

                            <span>
                                BALANCE :
                            </span>
                            <span style={{ color: "red" }}>
                                {`₹ ${walletBalance || 0}`}
                            </span>
                        </div>}
                    </div>


                    <div className="cards-grid">
                        {cards.map((card, index) => (
                            <div key={index} className={`dashboard-card ${card.color}`} onClick={card.action}>
                                <div className='icon-circle'>
                                    {card.logo}
                                </div>

                                <h3>{card.name}</h3>
                            </div>
                        ))}
                    </div>
                    {/* MIDDLE SECTION */}
                    <div className="middle-section">




                        <div className="right-box">
                            <div className="box-card">

                                <div className="card-header">
                                    <div className="title-wrap">
                                        <span className="icon-box">
                                            <TbTruckDelivery />
                                        </span>

                                        <span className="title">
                                            Delivery Status
                                        </span>
                                    </div>
                                </div>

                                <div className="status-grid">

                                    <div className="status-box blue">
                                        <h3>219</h3>
                                        <p>Total</p>
                                    </div>

                                    <div className="status-box green">
                                        <h3>132</h3>
                                        <p>Delivered</p>
                                    </div>

                                    <div className="status-box orange">
                                        <h3>36</h3>
                                        <p>Created</p>
                                    </div>

                                    <div className="status-box purple">
                                        <h3>31</h3>
                                        <p>In Transit</p>
                                    </div>

                                    <div className="status-box red">
                                        <h3>11</h3>
                                        <p>Cancelled</p>
                                    </div>

                                    <div className="status-box pink">
                                        <h3>0</h3>
                                        <p>Failed</p>
                                    </div>

                                    <div className="status-box violet">
                                        <h3>15</h3>
                                        <p>Picked Up</p>
                                    </div>

                                    <div className="status-box gray">
                                        <h3>0</h3>
                                        <p>Un-delivered</p>
                                    </div>

                                </div>

                            </div>
                            <div className="box-card">

                                <div className="card-header">
                                    <div className="title-wrap">
                                        <span className="icon-box">
                                            <TbTruckDelivery />
                                        </span>

                                        <span className="title">
                                            Delivery Status
                                        </span>
                                    </div>
                                </div>

                                <div className="status-grid">

                                    <div className="status-box blue">
                                        <h3>219</h3>
                                        <p>Total</p>
                                    </div>

                                    <div className="status-box green">
                                        <h3>132</h3>
                                        <p>Delivered</p>
                                    </div>

                                    <div className="status-box orange">
                                        <h3>36</h3>
                                        <p>Created</p>
                                    </div>

                                    <div className="status-box purple">
                                        <h3>31</h3>
                                        <p>In Transit</p>
                                    </div>

                                    <div className="status-box red">
                                        <h3>11</h3>
                                        <p>Cancelled</p>
                                    </div>

                                    <div className="status-box pink">
                                        <h3>0</h3>
                                        <p>Failed</p>
                                    </div>

                                    <div className="status-box violet">
                                        <h3>15</h3>
                                        <p>Picked Up</p>
                                    </div>

                                    <div className="status-box gray">
                                        <h3>0</h3>
                                        <p>Un-delivered</p>
                                    </div>

                                </div>

                            </div>
                        </div>




                        {/* STATISTIC */}
                        <div className="stat-card">
                            <div className="stat-header">
                                <b>Statistic</b>

                                <div className="dropdown">
                                    <button onClick={toggleDropdown} className="dropdown-btn">
                                        Select Option ▼
                                    </button>

                                    {isOpen && (
                                        <ul className="dropdown-menu">
                                            <li>This Month</li>
                                            <li>This Week</li>
                                            <li>Today</li>
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <ResponsiveContainer width="100%" height="90%">
                                <LineChart
                                    data={data1}
                                    margin={{
                                        top: 5,
                                        right: 10,
                                        left: -20,
                                        bottom: 5
                                    }}
                                >
                                    <XAxis
                                        dataKey="name"
                                        tick={{ fontSize: 12 }}
                                    />

                                    <YAxis
                                        tick={{ fontSize: 12 }}
                                        width={25}
                                    />

                                    <Tooltip />

                                    <Line
                                        type="monotone"
                                        dataKey="pv"
                                        stroke="purple"
                                        strokeWidth={2}
                                    />

                                    <Line
                                        type="monotone"
                                        dataKey="uv"
                                        stroke="#0088FE"
                                        strokeWidth={2}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>

                    </div>

                    <div className="middle-section">




                        <div className="right-box">
                            <div className="box-card">

                                <div className="card-header">
                                    <div className="title-wrap">
                                        <span className="icon-box">
                                            <TbTruckDelivery />
                                        </span>

                                         <div className="sub-div">
                <span className="title">
                    Courier
                </span>
                <span className="sub-text">
                    Top 5 Couriers
                </span>
            </div>
                                    </div>
                                </div>

                                <div className="chart-container">
        <ResponsiveContainer width="100%" height={300}>
  <BarChart
    layout="vertical"
    data={courierData}
    margin={{
      top: 20,
      right: 20,
      left: 0, // increase more
      bottom: 0
    }}
    barCategoryGap={18}
  >

    <YAxis
      dataKey="name"
      type="category"
      width={100}   // increase
      interval={0}  // show all labels
      tickLine={false}
      axisLine={false}
      tick={({x,y,payload})=>(
        <text
          x={x-10} // move text slightly left
          y={y}
          textAnchor="end"
          fontSize={12}
          fill="#666"
        >
          {payload.value.split("\n").map((line,i)=>(
            <tspan
              x={x-10}
              dy={i===0 ? 0 : 15}
              key={i}
            >
              {line}
            </tspan>
          ))}
        </text>
      )}
    />

    <XAxis
      type="number"
      domain={[0, 100]}
      ticks={[0,50,100]}
      tickFormatter={(v)=>`${v}%`}
      axisLine={false}
      tickLine={false}
    />

   
    {/* Black value bar */}
    <Bar
      dataKey="value"
      stackId="a"
      fill="#000"
      radius={[0,0,0,0]}
      barSize={25}
    />

    {/* Gray background */}
    <Bar
      dataKey="remaining"
      stackId="a"
       fill="#efefef"
       radius={[0, 8, 8, 0]}
      barSize={25}
    />

    

  </BarChart>
</ResponsiveContainer>
    </div>

                            </div>
                            <div className="box-card">

                                <div className="card-header">
                                    <div className="title-wrap">
                                        <span className="icon-box">
                                            <TbTruckDelivery />
                                        </span>

                                        <span className="title">
                                            Delivery Status
                                        </span>
                                    </div>
                                </div>

                                <div className="status-grid">

                                    <div className="status-box blue">
                                        <h3>219</h3>
                                        <p>Total</p>
                                    </div>

                                    <div className="status-box green">
                                        <h3>132</h3>
                                        <p>Delivered</p>
                                    </div>

                                    <div className="status-box orange">
                                        <h3>36</h3>
                                        <p>Created</p>
                                    </div>

                                    <div className="status-box purple">
                                        <h3>31</h3>
                                        <p>In Transit</p>
                                    </div>

                                    <div className="status-box red">
                                        <h3>11</h3>
                                        <p>Cancelled</p>
                                    </div>

                                    <div className="status-box pink">
                                        <h3>0</h3>
                                        <p>Failed</p>
                                    </div>

                                    <div className="status-box violet">
                                        <h3>15</h3>
                                        <p>Picked Up</p>
                                    </div>

                                    <div className="status-box gray">
                                        <h3>0</h3>
                                        <p>Un-delivered</p>
                                    </div>

                                </div>

                            </div>
                        </div>




                        {/* STATISTIC */}
                        <div className="stat-card">
                            <div className="stat-header">
                                <b>Statistic</b>

                                <div className="dropdown">
                                    <button onClick={toggleDropdown} className="dropdown-btn">
                                        Select Option ▼
                                    </button>

                                    {isOpen && (
                                        <ul className="dropdown-menu">
                                            <li>This Month</li>
                                            <li>This Week</li>
                                            <li>Today</li>
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <ResponsiveContainer width="100%" height="90%">
                                <LineChart
                                    data={data1}
                                    margin={{
                                        top: 5,
                                        right: 10,
                                        left: -20,
                                        bottom: 5
                                    }}
                                >
                                    <XAxis
                                        dataKey="name"
                                        tick={{ fontSize: 12 }}
                                    />

                                    <YAxis
                                        tick={{ fontSize: 12 }}
                                        width={25}
                                    />

                                    <Tooltip />

                                    <Line
                                        type="monotone"
                                        dataKey="pv"
                                        stroke="purple"
                                        strokeWidth={2}
                                    />

                                    <Line
                                        type="monotone"
                                        dataKey="uv"
                                        stroke="#0088FE"
                                        strokeWidth={2}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>

                    </div>


                    <div className="scan-card-wrapper">
                        {scanCard.map((item, index) => (
                            <div className="scan-card" key={index}>
                                <img src={item} alt={`scan-${index}`} />
                            </div>
                        ))}
                    </div>

                    {
                        isOpenTrack && (

                            <div className="modal-overlay">

                                <div className="track-modal">

                                    <div className="modal-header">

                                        <div>

                                            <h3>Track Shipment</h3>
                                            <p>Enter your docket number</p>

                                        </div>

                                        <button
                                            className="close-btn"
                                            onClick={() => setISOpenTrack(false)}
                                        >
                                            ✕
                                        </button>

                                    </div>

                                    <div className="modal-body">

                                        <input
                                            type="text"
                                            placeholder="Enter Docket No"
                                            value={docketNo}
                                            onChange={(e) => setDocketNo(e.target.value)}
                                        />

                                    </div>

                                    <div className="modal-footer">

                                        <button
                                            className="cancel-btn"
                                            onClick={() => setISOpenTrack(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="submit-btn"
                                            onClick={handleTrack}
                                        >
                                            Track Now
                                        </button>

                                    </div>

                                </div>

                            </div>

                        )
                    }

                    {
                        isOpenPin && (

                            <div className="modal-overlay">

                                <div className="track-modal">

                                    <div className="modal-header">

                                        <div>

                                            <h3>Track Pin Code</h3>
                                            <p>Enter Pin Code</p>

                                        </div>

                                        <button
                                            className="close-btn"
                                            onClick={() => setISOpenPin(false)}
                                        >
                                            ✕
                                        </button>

                                    </div>

                                    <div className="modal-body">

                                        <input
                                            type="tel"
                                            placeholder="Enter Pin Code"
                                            maxLength={6}
                                            value={pincode}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                setPincode(value);
                                            }}
                                        />

                                    </div>

                                    <div className="modal-footer">

                                        <button
                                            className="cancel-btn"
                                            onClick={() => setISOpenPin(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="submit-btn"
                                            onClick={handleTrackPin}
                                        >
                                            Track Now
                                        </button>

                                    </div>

                                </div>

                            </div>

                        )
                    }


                </div>
                <Footer />
            </div>
        </>
    )
}


export default Dashboard;